import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import AppWrapper from "./components/AppWrapper"
import AppWrapperPremier from "./components/AppWrapperPremier"
import Preview from "./components/Preview"
import Podborki from "./components/Podborki"
import PodborkaEdit from "./components/PodborkaEdit"
import PodborkaCreate from "./components/PodborkaCreate"
import Register from "./pages/Register";
import Auth from "./pages/Auth";
import FilmData from "./components/FilmData";

import React from "react";
import "./App.css";

// Компонент не принимает пропсы, поэтому указываем, что это React.FC без параметров
const App: React.FC = () => {

  //  * Функция проверяет, аутентифицирован ли пользователь.
  //  * Возвращает boolean.
  //  * localStorage.getItem возвращает string | null, поэтому проверка двойным "&&"
  //  * даст строку или null, поэтому приводим к boolean с помощью Boolean(...)

  const isAuthenticated = (): boolean => {
    return Boolean(
      localStorage.getItem("mediateka.Login") &&
        localStorage.getItem("mediateka.Token")
    );
  };

  return (
    <Router>
      <Routes>
        {/* Если пользователь аутентифицирован, рендерим AppWrapper, иначе перенаправляем на /auth */}
        <Route
          index
          element={isAuthenticated() ? <AppWrapper /> : <Navigate to="/auth" />}
        />

        {/* Страница Premier */}
        <Route path="/premier" element={<AppWrapperPremier />} />

        {/* Страница предпросмотра */}
        <Route path="/preview" element={<Preview />} />

        {/* Страница подборок */}
        <Route path="/collections" element={<Podborki />} />
        <Route path="/collections/create" element={<PodborkaCreate />} />
        <Route path="/collections/:id" element={<PodborkaEdit />} />

        {/* Страница авторизации, при успешном логине делаем редирект */}
        <Route
          path="/auth"
          element={<Auth onAuthSuccess={() => (window.location.href = "/")} />}
        />
        {/* Страница фильмдата, где будут параметры фильмов */}
        <Route path="/filmdata" element={<FilmData />} />

        {/* Редирект для любых несуществующих роутов */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
